module.exports = __webpack_public_path__ + "static/media/cross.48d45067.svg";